/* MAX AUTO: public aggregates only. No customer identity or financial details. */
(() => {
  if (window.maxautoAvailabilityLoaded) return;
  window.maxautoAvailabilityLoaded = true;
  const endpoint = 'https://account.maxkauto.com/api/public/vehicle-activity';
  const T = (k, f, v) => (window.maxT ? window.maxT(k, f, v) : f.replace(/\{(\w+)\}/g, (m, x) => (v && x in v ? v[x] : m)));
  const TP = (k, n, f) => (window.maxTP ? window.maxTP(k, n, f) : T(k, n === 1 ? f.one : f.other, {count: n}));
  const labels = {confirm:T('common.avail_confirm','Confirm availability'),checking:T('common.avail_checking','Availability being confirmed'),in_progress:T('common.avail_reserved','Reserved'),unavailable:T('common.avail_unavailable','No longer available')};
  const cache = new Map();
  let busy = false, timer;
  const nodes = () => [...document.querySelectorAll('[data-maxauto-availability]')].filter(el => /^[1-9][0-9]{0,19}$/.test(el.dataset.maxautoAvailability || ''));
  const elapsed = record => Math.max(0, performance.now() - record.at, Date.now() - record.wallAt);
  const text = (el, value) => { if (el && el.textContent !== value) el.textContent = value; };
  function line(el, name) {
    let p = el.querySelector('[data-availability-' + name + ']');
    if (!p) { p = document.createElement('p'); p.setAttribute('data-availability-' + name, ''); p.hidden = true; el.appendChild(p); }
    return p;
  }
  function render(el, record) {
    const fresh = record && elapsed(record) <= 90000;
    const data = fresh ? record.item : {state:'checking',piCustomerCount:0,reservation:null};
    let state = Object.hasOwn(labels, data.state) ? data.state : 'checking';
    if (el.dataset.maxautoFallback === 'unavailable' && state === 'confirm') state = 'unavailable';
    const compact = el.dataset.maxautoCompact === 'true';
    const quiet = compact && (state === 'confirm' || state === 'checking');
    const count = data.piCustomerCount || 0;
    el.dataset.state = state;
    // Preserve the current theme's quiet collection cards, unless a real count exists.
    el.hidden = quiet && count === 0;
    const label = el.querySelector('[data-availability-label]');
    if (label) { label.hidden = quiet; text(label, labels[state]); }
    const interest = line(el, 'interest');
    interest.hidden = count === 0;
    text(interest, count ? TP('common.avail_pi_customers', count, {one:'{count} customer received a PI · last 30 days', other:'{count} customers received a PI · last 30 days'}) : '');
    const countdown = line(el, 'countdown'), deadline = line(el, 'deadline');
    let deadlineText = '';
    deadline.hidden = true;
    let timing = '';
    if (state === 'in_progress' && data.reservation) {
      const due = Date.parse(data.reservation.reviewAt);
      const remaining = due - record.serverAt - record.roundTrip - elapsed(record);
      if (data.reservation.phase === 'held' && remaining > 0) {
        const minutes = Math.ceil(remaining / 60000);
        timing = T('common.avail_review_in', 'Reservation review in {h}h {m}m', {h: Math.floor(minutes / 60), m: String(minutes % 60).padStart(2, '0')});
        deadlineText = T('common.avail_review_by', 'Review by {time} UTC', {time: new Date(due).toISOString().slice(0, 16).replace('T', ' ')});
        countdown.title = deadlineText;
        deadline.hidden = compact;
      } else { timing = T('common.avail_under_review', 'Reservation under review'); countdown.title = ''; }
    } else countdown.title = '';
    text(deadline, deadlineText);
    countdown.hidden = !timing;
    text(countdown, timing);
    const note = el.querySelector('[data-availability-note]');
    if (note) text(note, state === 'in_progress' ? T('common.avail_note_reserved', 'Availability is confirmed after our reservation review. Contact us on WhatsApp for an update.') : state === 'unavailable' ? T('common.avail_note_unavailable', 'Contact us to find a similar vehicle.') : state === 'checking' ? T('common.avail_note_checking', 'Our team will confirm the latest vehicle availability on WhatsApp.') : T('common.avail_note_confirm', 'Please confirm via WhatsApp first.'));
  }
  function valid(item, ids) {
    if (!item || !ids.includes(item.productId) || !Object.hasOwn(labels, item.state) || !Number.isSafeInteger(item.piCustomerCount) || item.piCustomerCount < 0) return false;
    if (item.reservation === null) return true;
    return item.state === 'in_progress' && item.reservation && (item.reservation.phase === 'review' && item.reservation.reviewAt === null || item.reservation.phase === 'held' && typeof item.reservation.reviewAt === 'string' && Number.isFinite(Date.parse(item.reservation.reviewAt)));
  }
  async function refresh(force = false) {
    if (busy || document.hidden) return;
    const visible = nodes(), ids = [...new Set(visible.map(el => el.dataset.maxautoAvailability))];
    const pending = ids.filter(id => force || !cache.has(id) || elapsed(cache.get(id)) >= 60000);
    visible.forEach(el => render(el, cache.get(el.dataset.maxautoAvailability)));
    if (!pending.length) return;
    busy = true;
    try {
      for (let i = 0; i < pending.length; i += 40) {
        const batch = pending.slice(i, i + 40), started = performance.now();
        let items, serverAt = 0;
        try {
          const response = await fetch(endpoint + '?' + new URLSearchParams({ids:batch.join(',')}), {credentials:'omit',cache:'no-store',referrerPolicy:'no-referrer',signal:AbortSignal.timeout(8000)});
          if (!response.ok) throw Error();
          const result = await response.json();
          serverAt = Date.parse(result.serverTime);
          if (!Number.isFinite(serverAt) || result.inquiryWindowDays !== 30 || !Array.isArray(result.items) || result.items.length !== batch.length || !result.items.every(x => valid(x, batch))) throw Error();
          items = new Map(result.items.map(x => [x.productId, x]));
          if (items.size !== batch.length) throw Error();
        } catch { items = new Map(batch.map(id => [id, {state:'checking',piCustomerCount:0,reservation:null}])); }
        const at = performance.now(), wallAt = Date.now(), roundTrip = at - started;
        batch.forEach(id => cache.set(id, {item:items.get(id),at,wallAt,serverAt,roundTrip}));
        nodes().forEach(el => { if (batch.includes(el.dataset.maxautoAvailability)) render(el, cache.get(el.dataset.maxautoAvailability)); });
      }
    } finally { busy = false; schedule(); }
  }
  const schedule = () => { clearTimeout(timer); timer = setTimeout(() => refresh(), 150); };
  new MutationObserver(changes => { if (changes.some(change => [...change.addedNodes].some(n => n.nodeType === 1 && (n.matches('[data-maxauto-availability]') || n.querySelector('[data-maxauto-availability]'))))) schedule(); }).observe(document.documentElement, {childList:true,subtree:true});
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(true); });
  window.addEventListener('pageshow', () => refresh(true));
  setInterval(() => refresh(true), 60000);
  setInterval(() => { if (!document.hidden) nodes().forEach(el => render(el, cache.get(el.dataset.maxautoAvailability))); }, 10000);
  schedule();
})();
